import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScrollProvider } from "@/lib/smooth-scroll";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <SmoothScrollProvider>
                <Home />
              </SmoothScrollProvider>
            }
          />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        richColors
        position="bottom-right"
        toastOptions={{ style: { fontFamily: "'Manrope', sans-serif", borderRadius: "6px" } }}
      />
    </div>
  );
}

export default App;
